import { saveAs } from 'file-saver'

/**
 * ファイルダウンロード
 *
 * サーバー問い合わせをせず、指定されたコンテンツを通常のダウンロードダイアログ
 * からダウンロードさせます。
 *
 * TODO Blob以外で来た場合、csvとしてダウンロードさせている。必要が出てきたら指定できるようにする。
 */
export default function download(content, filename) {
  let blob
  if (content instanceof Blob) {
    blob = content
  } else {
    blob = new Blob([content], { type: 'text/csv;charset=utf-8' })
  }
  saveAs(blob, filename)
}
